import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FilterIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'sm' : _b;
    var iconSize = {
        sm: {
            width: 16,
            height: 16,
        },
        md: {
            width: 24,
            height: 24,
        },
        lg: {
            width: 30,
            height: 30,
        },
    };
    return (_jsxs("svg", { width: iconSize[size].width, height: iconSize[size].height, viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: [_jsx("path", { d: 'M10.2858 9.41701L15.4904 4.19569C15.816 3.8683 16 3.42114 16 2.95446V1.42311C16 0.462244 15.2377 0 14.2973 0H1.70272C0.762362 0 0 0.462244 0 1.42311V2.98196C0 3.4238 0.164107 3.84967 0.460196 4.17262L5.24189 9.38951C5.33219 9.48799 5.45809 9.54388 5.59094 9.54477L9.94804 9.5572C10.0739 9.55808 10.1955 9.50839 10.2858 9.41701Z', fill: 'white' }), _jsx("path", { opacity: '0.4', d: 'M5.38672 9.49841V15.3692C5.38672 15.583 5.49439 15.7844 5.67065 15.8997C5.77137 15.9663 5.88772 16 6.00408 16C6.09177 16 6.17947 15.9814 6.26109 15.9441L9.78636 14.301C10.0069 14.1989 10.1484 13.9745 10.1484 13.7269V9.49841H5.38672Z', fill: 'white' })] }));
};
